import React, { Fragment } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { NotFoundContainer, Title, Description } from "./layout.mjs";
import Head from "layout/Head";

import { useTranslation } from "hooks/useTranslation";

const NotFound = ({ language = "en" }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("Not Found")}
        description={t("sorry")}
        url="https://ui.com/"
        image="https://ui.com/microsite/og-image.png"
      />
      <Switch>
        <Route
          path="/"
          render={() => (
            <NotFoundContainer>
              <Title>{t("404")}</Title>
              <Description>{t("sorry")}</Description>
            </NotFoundContainer>
          )}
        />
      </Switch>
    </Fragment>
  );
};

export default withRouter(NotFound);
